/** Shared username rules: ASCII letters, digits, underscore; length 3–20.
 * Auto-generated names from the API are `Dino` + 6 lowercase hex digits.
 */

export const minUsernameLength = 3;
export const maxUsernameLength = 20;

export const usernamePattern = /^[A-Za-z0-9_]+$/;

/** Matches generateUsername on the API: `"Dino" + hex.EncodeToString(3 bytes)`. */
export const autoGeneratedUsernamePattern = /^Dino[0-9a-f]{6}$/;

export type UsernameValidationError = 'length' | 'chars';

/** Returns null when `raw` is a valid username (after trim). */
export function validateUsername(raw: string): UsernameValidationError | null {
  const username = raw.trim();
  if (username.length < minUsernameLength || username.length > maxUsernameLength) {
    return 'length';
  }
  if (!usernamePattern.test(username)) {
    return 'chars';
  }
  return null;
}

/** True when `username` looks like a server auto-generated display name. */
export function isAutoGeneratedUsername(username: string): boolean {
  return autoGeneratedUsernamePattern.test(username.trim());
}
